"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSDKVersion = void 0;
const package_json_1 = __importDefault(require("../package.json"));
// Slice is needed for versions like '1.0.0-beta.0'
const getSDKVersion = () => package_json_1.default.version.slice(0, 5);
exports.getSDKVersion = getSDKVersion;
//# sourceMappingURL=utils.js.map